module.exports = __webpack_public_path__ + "static/media/AvantGardeMedium.c410806c.svg";